export default __webpack_public_path__ + "static/media/cross-section.d7ae5cdf.svg";